var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"groupItem"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("content"),(_vm.desc)?_c('div',{staticClass:"desc"},[_vm._v(" "+_vm._s(_vm.desc)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }